const caseDataVerification = {
  get: controlNumber => `/case-data-verification/${controlNumber}`,
  getForms: controlNumber => `/case-data-verification/${controlNumber}/forms`,
};

export default caseDataVerification;
